var angular=window.angular,ngModule;
try {ngModule=angular.module(["ikeweb.templates"])}
catch(e){ngModule=angular.module("ikeweb.templates",[])}
var v1="<a class=\"EolNotice\" href=\"{{ ctrl.eolTermsUrl }}\" target=\"_blank\" rel=\"noopener noreferrer\">\n{{ 'COMPONENT.EOL_NOTICE.MESSAGE' | translate }}\n</a>";
var id1="eol-notice.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;


//////////////////
// WEBPACK FOOTER
// ./src/client/components/eol-notice/eol-notice.html
// module id = 449
// module chunks = 0